const DEPLOYMENT_VERSION_ENDPOINT = "/api/deployment-version";

type FetchDeploymentVersionOptions = {
  fetcher?: typeof fetch;
  signal?: AbortSignal;
};

export async function isDeploymentUpdateAvailable(
  loadedDeploymentId: string | undefined,
  options: FetchDeploymentVersionOptions = {},
) {
  if (!loadedDeploymentId) return false;

  const response = await (options.fetcher ?? fetch)(
    `${DEPLOYMENT_VERSION_ENDPOINT}?loaded=${encodeURIComponent(loadedDeploymentId)}`,
    {
      cache: "no-store",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      signal: options.signal,
    },
  );
  if (!response.ok) return false;

  const payload: unknown = await response.json();
  const currentDeploymentId =
    typeof payload === "object" &&
    payload !== null &&
    "deploymentId" in payload &&
    typeof payload.deploymentId === "string"
      ? payload.deploymentId
      : null;

  return Boolean(
    currentDeploymentId && currentDeploymentId !== loadedDeploymentId,
  );
}
